module.exports = __webpack_public_path__ + "static/index/img/baikal-804.36e5b32f.jpg";